export default class CreateBrandRequest {
    code;
    title;
    description;

    static fromJson = (json = {}) => {
        var createBrandRequest = new CreateBrandRequest();
        createBrandRequest = json;
        return createBrandRequest;
    }
}